module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group radio-list ';
 if (hide) { ;
__p += 'hidden';
 } ;
__p += '">\n  <label>' +
((__t = ( question )) == null ? '' : __t) +
'</label>\n  <span class="help-block hidden"></span>\n  ';
 _.each(answer, function(answer){ ;
__p += '\n    <input type="radio" id="' +
((__t = ( id )) == null ? '' : __t) +
'-' +
((__t = ( answer.id )) == null ? '' : __t) +
'" name="' +
((__t = ( id )) == null ? '' : __t) +
'" value="' +
((__t = ( answer.id )) == null ? '' : __t) +
'"\n        ';
 if (answer.id == response) { ;
__p += 'checked';
 } ;
__p += '\n    >\n    <label for="' +
((__t = ( id )) == null ? '' : __t) +
'-' +
((__t = ( answer.id )) == null ? '' : __t) +
'">' +
((__t = ( answer.value )) == null ? '' : __t) +
'</label>\n  ';
 }); ;
__p += '\n</div>\n\n';

}
return __p
}